import { LayoutsModule } from 'src/app/layouts/layouts.module';
import { NgModule } from '@angular/core';
import { ProjectListComponent } from './list/project-list.component';
import { Routes, RouterModule } from '@angular/router';
import { projectPages } from './projects.routes';
import { ProjectCreateComponent } from '@app/pages/project/create/project-create.component';
import { ProjectEditComponent } from '@app/pages/project/edit/project-edit.component';
import { AuthGuard } from '@app/components/cleanui/system/Guard/auth.guard';
import { PrivacyGuard } from '@app/components/cleanui/system/Guard/privacy.guard';

// Projekt-Seiten

export const projectRoutes: Routes = [
	{
		path: projectPages.dashboard.url,
		component: ProjectListComponent,
		data: {
			title: 'Projekte - Übersicht',
			permissions: ['projects:read'],
		},
		canActivate: [AuthGuard, PrivacyGuard],
	},
	{
		path: projectPages.create.url,
		component: ProjectCreateComponent,
		data: {
			title: 'Projekt Erstellen',
			permissions: ['projects:create'],
		},
		canActivate: [AuthGuard, PrivacyGuard],
	},{
		path: projectPages.edit.url,
		component: ProjectEditComponent,
		data: {
			title: 'Projekt Bearbeiten',
			permissions: ['projects:read'],
		},
		canActivate: [AuthGuard, PrivacyGuard],
	},
];

@NgModule({
	imports: [LayoutsModule, RouterModule.forChild(projectRoutes)],
	providers: [],
	exports: [RouterModule]
})
export class ProjectsRoutingModule {}
